import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class TokenService implements HttpInterceptor{
  constructor(private router: Router) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {    
    const xAccessToken = localStorage.getItem('token');

    if (request.url.includes('/login') || request.url.includes('/register')) {
      return next.handle(request);
    }

    let newHeaders = request.headers;
    if (xAccessToken) {
      newHeaders = newHeaders.append('x-access-token', xAccessToken);
    }

    const authReq = request.clone({ headers: newHeaders });

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403 && error.error?.message === 'Token has expired') {
          this.logout();
        }
        return throwError(() => error);
      })
    );
  }

  private logout() {
    localStorage.clear();
    this.router.navigate(['/']);
  }
}
